import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import TermsPage from "@/pages/Terms";
import PrivacyPage from "@/pages/Privacy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#141518",
            color: "#FAF9F5",
            border: "1px solid rgba(250,249,245,0.12)",
            borderRadius: "999px",
            fontFamily: "'Plus Jakarta Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
